/** Map the features in platform by id */
export enum FeatureMappingEnum {
    PLANNING = '14',
    DATA_SOLUTIONS = '2',
    TOOLS = '0'
}

/** Levels of user entitlement */
export enum EntitlementLevelEnum {
    FEATURE,
    NATION,
    PRODUCT,
    REPORT,
    SCHEDULER,
    EXTERNAL_LINK
}
